import type { RefObject } from 'react';
import type { DocumentFile, DocumentFolder, DocumentPermission } from '../../types';
import type { DragItemData } from '../document-explorer/useDragAndDrop';

export interface DocumentListProps {
  folders: DocumentFolder[];
  files: DocumentFile[];
  permission: DocumentPermission;
  deviceModelNames: Map<number, string>;
  onFolderClick: (folder: DocumentFolder) => void;
  onFileClick: (file: DocumentFile) => void;
  onFolderAction: (actionLabel: FolderAction, folder: DocumentFolder) => void;
  editingFolderId: string | null;
  editingFolderName: string;
  isRenamingFolder: boolean;
  onFolderRenameStart: (folder: DocumentFolder) => void;
  onFolderRenameChange: (value: string) => void;
  onFolderRenameSubmit: (folder: DocumentFolder) => void;
  onFolderRenameCancel: () => void;
  onFileAction: (actionLabel: FileAction, file: DocumentFile) => void;
  sentinelRef: RefObject<HTMLDivElement | null>;
  isFetchingNextPage: boolean;
  // DnD
  isDndActive?: boolean;
  draggedItem?: DragItemData | null;
  // Multiselect
  isSelected?: (id: string) => boolean;
  onToggleSelect?: (item: DocumentFile | DocumentFolder) => void;
  // Floating action bar
  selectedCount?: number;
  isBulkMoving?: boolean;
  isBulkDeleting?: boolean;
  onBulkMoveClick?: () => void;
  onBulkDeleteClick?: () => void;
}

export interface DocumentTableHeaderProps {
  isAdmin: boolean;
}

export interface FolderActionsProps {
  folder: DocumentFolder;
  onAction: (actionLabel: FolderAction, folder: DocumentFolder) => void;
}

export interface FileActionsProps {
  file: DocumentFile;
  onAction: (actionLabel: FileAction, file: DocumentFile) => void;
}

export interface FolderRowProps {
  folder: DocumentFolder;
  isAdmin: boolean;
  isEditingFolder: boolean;
  editingFolderName: string;
  isRenamingFolder: boolean;
  renameInputRef: RefObject<HTMLInputElement | null>;
  onFolderClick: (folder: DocumentFolder) => void;
  onFolderAction: (actionLabel: FolderAction, folder: DocumentFolder) => void;
  onFolderRenameStart: (folder: DocumentFolder) => void;
  onFolderRenameChange: (value: string) => void;
  onFolderRenameSubmit: (folder: DocumentFolder) => void;
  onFolderRenameCancel: () => void;
  // DnD
  isDndActive?: boolean;
  isDraggedItem?: boolean;
  // Multiselect
  isSelected?: boolean;
  onToggleSelect?: (folder: DocumentFolder) => void;
}

export interface FileRowProps {
  file: DocumentFile;
  isAdmin: boolean;
  deviceModelNames: Map<number, string>;
  languageNamesById: Map<number, string>;
  onFileClick: (file: DocumentFile) => void;
  onFileAction: (actionLabel: FileAction, file: DocumentFile) => void;
  // DnD
  isDndActive?: boolean;
  isDraggedItem?: boolean;
  // Multiselect
  isSelected?: boolean;
  onToggleSelect?: (file: DocumentFile) => void;
}

export interface DeviceModelSummary {
  label: string;
  title?: string;
}


export enum FileAction{
  Move = 'move',
  Delete = 'delete',
}

export enum FolderAction{
  Move = 'move',
  Delete = 'delete',
  Rename = 'rename',
}